<template>
  <Modal
    v-model:visible="isVisible"
    class="loadboard-post-result-modal"
    :header="t('common.results', 2)"
    @keypress.esc="isVisible = false"
  >
    <Section
      v-if="successes.length"
      id="successful-loadboards-section"
      :header="t('rateShop.successfulLoadboardPosts')"
    >
      <ul>
        <li v-for="(loadboard, i) in successes" :key="`successful-post-${i}`">
          {{
            loadboard.loadboard?.source
              ? translateEnum(loadboard.loadboard.source, 'LoadboardSource')
              : loadboard.loadboard?.source
          }}
        </li>
      </ul>
    </Section>
    <Section
      v-if="allErrors.length"
      id="errors-section"
      :header="t('errors.errors', 2)"
    >
      <ul>
        <li v-for="(error, i) in allErrors" :key="`error-${i}`">
          <template v-if="error.source">
            <strong>
              {{ translateEnum(error.source, 'LoadboardSource') }}
            </strong>
            &mdash;
          </template>
          {{ error.message }}
          <ul
            v-if="error.details && Object.keys(error.details).length"
            class="error-details"
          >
            <li
              v-for="(value, key) in error.details"
              :key="`detail-${i}-${key}`"
            >
              {{ key }}: {{ value }}
            </li>
          </ul>
        </li>
      </ul>
    </Section>
    <template #footer>
      <RygenButton
        mode="tertiary"
        :label="t('common.close')"
        @click="isVisible = false"
      />
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { translateEnum } from '@rygen/rygen-ui/i18n';

import { LoadboardError, PostToLoadboardResponse } from '@/model';

import RygenButton from '@rygen/rygen-ui/components/button/RygenButton.vue';
import Modal from '@rygen/rygen-ui/components/ui/Modal.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const isVisible = defineModel('visible', {
  type: Boolean,
  default: () => false,
});

const props = defineProps({
  responses: {
    type: Array<PostToLoadboardResponse>,
    default: [],
  },
});

const { responses } = toRefs(props);

const { t } = useI18n();

const successes = computed(() => {
  return responses.value
    .filter((r) => !r.errors?.length)
    .filter((r) => r.loadboard != null);
});

const allErrors = computed((): LoadboardError[] => {
  return responses.value.flatMap((r) => r.errors ?? []);
});
</script>

<style>
.loadboard-post-result-modal {
  .error-details {
    margin-top: var(--sp-1);
    font-size: var(--p-text-sm);
    opacity: 0.7;
    list-style-type: disc;
  }
}
</style>
